/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![StageModeratorIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABrUlEQVR4nM2VzUocQRDH2yhJPPoCBg3JGwQUhD1plszUxyz0VM1eFsU8g8cFySk5xCQs5OxjCF4i6CkeBO8qaMAP1EURPag0WUV2pvdr9mBBwdDz7/+vq2um25jnEGFoR5GlhixHjay5sb4YA8kPJLlC1runCSQ3yLrMLG/7aox5QNbaYST9BaTX7YwxBXJz5GehUnntBQDL726NMZVS8wKQ5TwvAEjPWgDaGGA8i6xz7XS9AUj/WWsHq9XqC2DZ7xfgFlm+A8kCRho86iIN3BiQLv3XdA64bFr1obX2pU9fLBZfAclxU5MvvABg3Us1jfUPgB1LacGOIclaRtW7/gpIVj37+i0FIP2a3StZ8VdA+iVrUsjJlHsfBOURl+455GTSs5hFPyCKJzIBlDBRAu7rAZIDREVgoUxtFH/wAhp92O75J2PZamneACS9AzRuCzDGDCDpRtcAknU3txOA+VQqvwHSky625jQolcdNN0EUf+zkPnAaiHTa9BIQaRFY6y32vB6yzJg8wSzvgWUz4/D7G5SSd7nMH6JQKAwh62ck2XFJlMy7k7Uv5nnjHqw6KNUXo4tOAAAAAElFTkSuQmCC)
 */
export const StageModeratorIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M4.56 4.36A2.83 2.83 0 0 0 3 6.9v3.03c0 5.6 3.3 10.68 8.42 12.96.37.16.79.16 1.16 0A14.18 14.18 0 0 0 21 9.92V6.9c0-1.07-.6-2.05-1.56-2.53l-6.1-3.04a3 3 0 0 0-2.68 0l-6.1 3.04Zm8.25 3.3a.85.85 0 0 0-1.62 0l-.55 1.64a.25.25 0 0 1-.24.17H8.7a.85.85 0 0 0-.5 1.55l1.35.94c.1.07.13.18.1.29l-.53 1.57a.85.85 0 0 0 1.3.97l1.44-1.02c.08-.06.2-.06.28 0l1.45 1.02a.85.85 0 0 0 1.3-.97l-.54-1.57c-.03-.1 0-.22.1-.29l1.34-.94a.85.85 0 0 0-.49-1.55h-1.7c-.11 0-.2-.06-.24-.17l-.55-1.64Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
